export const globalSpacer = 4

export const getSpacer = n => globalSpacer * n
